





















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import CreditCard from '@/components/CreditCard.vue'
import eCheckCard from '@/components/eCheckCard.vue'
import EditPaymentModal from './EditPaymentModal.vue'
import PaymentMethodModal from '@/components/modals/PaymentMethodModal.vue'
import {
  EPaymentReceiptType,
  EPaymentMethodType,
  IResidentPaymentMethod,
  EAutoPayItemStatus,
  ISchedulePaymentSetting,
  IPayment,
  IResident
} from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'

@Component({
  props: {
    scheduleItemProp: {
      type: Object,
      required: true
    }
  },
  components: {
    CreditCard,
    EditPaymentModal,
    eCheckCard,
    PaymentMethodModal
  }
})
export default class ReviewPaymentMethod extends Vue {
  EPaymentReceiptType: any = EPaymentReceiptType
  EPaymentMethodType: any = EPaymentMethodType
  EAutoPayItemStatus: any = EAutoPayItemStatus
  editPaymentModalOpened: boolean = false
  wantAddPaymentMethod: boolean = false
  wantChangePaymentMethod: boolean = false
  editPaymentData: IResidentPaymentMethod | null = null
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)

  get scheduleItem () {
    return this.$props.scheduleItemProp
  }

  get residentId () {
    return (this.setting.resident as IResident).id
  }

  get setting () {
    return this.scheduleItem.setting as ISchedulePaymentSetting
  }

  get paymentMethod () {
    return this.setting.paymentMethod as IResidentPaymentMethod
  }

  set paymentMethod (v : IResidentPaymentMethod) {
    this.setting.paymentMethod = v
  }
  
  get payment () {
    return this.scheduleItem.payment as IPayment
  }
  
  setEditPaymentModalOpened (val: boolean) {
    this.editPaymentModalOpened = val
  }

  async changePaymentMethod (paymentMethod: IResidentPaymentMethod) {
    await this.paymentsModuleInstance.scheduleItemChangePaymentMethod({
      scheduleItem: this.scheduleItem,
      paymentMethod
    })
    this.setEditPaymentModalOpened(false)
  }

  addNewPaymentMethod () {
    this.setEditPaymentModalOpened(false)
    this.wantAddPaymentMethod = true
  }

  changePaymentMethodModal () {
    this.setEditPaymentModalOpened(true)
  }

  closeAddPaymentMethodModal () {
    this.wantAddPaymentMethod = false
    this.wantChangePaymentMethod = false
    if (this.editPaymentData) this.editPaymentData = null
  }

  setEditPaymentMethod (paymentMethod: IResidentPaymentMethod) {
    this.paymentMethod = {
      ...this.paymentMethod,
      ...paymentMethod
    } 
  }

  openEditModal (id: number) {
    this.editPaymentData = this.paymentMethod
    this.wantAddPaymentMethod = true
  }
}
